export const getSuccessRateColor = (successRate: number): 'success' | 'warning' | 'error' => {
  if (successRate >= 95) return 'success';
  if (successRate >= 90) return 'warning';
  return 'error';
};

export const getStatusColor = (successRate: number | null): 'default' | 'success' | 'warning' | 'error' => {
  if (successRate === null) return 'default';
  if (successRate >= 99) return 'success';
  if (successRate >= 90) return 'warning';
  return 'error';
};

export const getStatusLabel = (successRate: number | null): string => {
  if (successRate === null) return 'No Data';
  if (successRate >= 99) return 'Operational';
  if (successRate >= 90) return 'Degraded';
  return 'Major Issues';
};

export const getExecutionTimeColor = (executionTime: number): 'error.main' | 'warning.main' | 'text.primary' => {
  if (executionTime > 5000) return 'error.main';
  if (executionTime > 2000) return 'warning.main';
  return 'text.primary';
};

// Color for an HTTP status code: 5xx red, 4xx orange, 2xx/3xx green, unknown muted navy.
export const statusCodeColor = (code: number | null): string => {
  if (code === null) return 'rgba(21, 24, 58, 0.5)';
  if (code >= 500) return '#E7233B';
  if (code >= 400) return '#CF5C09';
  return '#53B721';
};
